'use client';

import { useCallback } from 'react';
import { useInvalidatePurchasedTickets } from '../../../../lottery-purchases/hooks/useInvalidatePurchasedTickets';
import { clearPurchasedTicketsReturnState } from '../../../../lottery-purchases/PurchasedTickets/hooks/usePurchasedTicketsTabs';
import type { CartResponse } from '../types';

type CheckoutSideEffectHandler = {
  matches: (cart: CartResponse) => boolean;
  run: () => void;
};

function useCheckoutSideEffects() {
  const { invalidatePurchasedTickets } = useInvalidatePurchasedTickets();

  const runCheckoutSideEffects = useCallback(
    (cart: CartResponse) => {
      const lotteryCheckoutSideEffects: CheckoutSideEffectHandler = {
        matches: cartResponse => cartResponse.tickets?.some(ticket => ticket.type === 'LOTTO') ?? false,
        run: () => {
          invalidatePurchasedTickets();
          clearPurchasedTicketsReturnState();
        },
      };

      const sideEffectHandlers = [lotteryCheckoutSideEffects /*, scratchcard... */];

      sideEffectHandlers.filter(handler => handler.matches(cart)).forEach(handler => handler.run());
    },
    [invalidatePurchasedTickets]
  );

  return { runCheckoutSideEffects };
}

export { useCheckoutSideEffects };
